module.exports = __webpack_public_path__ + "img/icon-plus.605c330f.svg";